const getQueryParameter = (param?: string | string[]) => (Array.isArray(param) ? param[0] : param);

export default getQueryParameter;
